import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import OptionsStep from "./OptionsStep";


class ChoseLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            locations: {},
            trigger: false,
            options: [],
        };

    }

    componentWillMount() {
        // const self = this;
        const {steps} = this.props;
        const params = {
            services:[steps.serviceId.value]
        };
        API.get('/getLocations',{params}).then((res) => {
            const result = res.data;
            var options = [];
            if (result.status == "success") {
                this.setState(
                    {loading: false}
                );
                if(result.data.length>0){
                    result.data.forEach(function (item, i, arr) {
                        options.push({value: item.id, label: item.name});
                    });

                    this.setState(
                        { options: options}
                    );
                }
            }

        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }


    render() {
        const {trigger, loading, locations,options} = this.state;
        const {steps, step} = this.props;

        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (

                    <OptionsStep
                        // key={index}
                        options={options}
                        step={step}
                        speak={this.speak}
                        // previousValue={previousStep.value}
                        triggerNextStep={this.props.triggerNextStep}
                        // bubbleOptionStyle={bubbleOptionStyle}
                    />
                )}
            </div>
        );
    }
}

ChoseLocation.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

ChoseLocation.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default ChoseLocation;
